module.exports = __webpack_public_path__ + "img/button_delete_close_x.47711f3f.svg";